<template>
  <div class="flex items-center gap-2">
    <div
      class="inline-flex size-6 items-center justify-center rounded-full"
      :class="
        entry.amount > 0
          ? 'bg-green-100 text-green-700'
          : entry.amount < 0
            ? 'bg-bittersweet-100 text-bittersweet-700'
            : 'bg-obsidian-100 text-obsidian-600'
      "
    >
      <ArrowUpRightIcon v-if="entry.amount > 0" class="size-4" />
      <ArrowDownRightIcon v-else-if="entry.amount < 0" class="size-4" />
      <MinusIcon v-else class="size-3" />
    </div>
    <div>
      <div class="flex items-center gap-2 text-xs">
        <slot name="beforeLane" />
        <span class="text-obsidian-700">
          {{ getTranslatedLedgerEntryLane(entry.lane, entry.description) }}
        </span>
      </div>
      <div>{{ getLocalizedField(entry.readableDescription) || '-' }}</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ArrowDownRightIcon, ArrowUpRightIcon, MinusIcon } from 'lucide-vue-next';
import { getTranslatedLedgerEntryLane } from '@/utils/get-translated-ledger-entry-lane.ts';
import { useLocalizedFields } from '@/hooks/use-localized-fields.ts';
import type { LedgerEntry } from '@/entities/ledger/ledger-entry.entity.ts';

const { getLocalizedField } = useLocalizedFields();

const props = defineProps<{
  entry: LedgerEntry;
}>();
</script>
